import { render } from "./MainLayout_v2.vue?vue&type=template&id=6ed2ccd2"
import script from "./MainLayout_v2.vue?vue&type=script&lang=js"
export * from "./MainLayout_v2.vue?vue&type=script&lang=js"

import "./MainLayout_v2.vue?vue&type=style&index=0&id=6ed2ccd2&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__